import { STATES } from '../../pages/Cadastro/Steps/Step2/constants';
import { OnBoardingData } from './types';

export const BRAZILIAN_STATES = STATES;

export const GOAL_OPTIONS = [
  'Realizar cálculos e consultas jurídicas',
  'Monitorar meus processos e fazer gestão de meus prazos',
  'Utilizar inteligência artificial para me ajudar no dia a dia',
  'Expandir minha carteira de clientes',
  'Criar meu site profissional',
  'Facilitar a assinatura de documentos digitais',
  'Conectar com a comunidade da Jusfy',
];

export const REWARD_ITEMS = [
  'Assinaturas digitais',
  'Desbloqueios para prospecção de clientes',
  'Consultas de CPF, CNPJ ou placa de veículo',
];

export const DEFAULT_DATA: OnBoardingData = {
  oabNumber: '',
  oabState: '',
  goals: [],
  officeSize: '',
};
